var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkDownAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 128,
    viewBox: "0 0 122 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0645,
    y: 17.9937,
    width: 92.2812,
    height: 92.2812,
    rx: 46.1406,
    fill: "#4B5563"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.0039 90.6655L55.0039 90.6655C54.8593 90.6655 54.7602 90.6045 54.7197 90.563C55.4746 87.8003 58.1802 85.6655 61.5039 85.6655C64.8277 85.6655 67.5343 87.8002 68.2891 90.563C68.2489 90.6045 68.1491 90.6655 68.0039 90.6655Z",
    fill: "#1F2937",
    stroke: "#1F2937",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.207 68.6265C79.5496 69.5341 78.6053 70.2886 77.4683 70.8149C76.3312 71.3413 75.041 71.621 73.7261 71.6264C72.4112 71.6317 71.1175 71.3625 69.9737 70.8455C68.83 70.3284 67.8761 69.5816 67.207 68.6794",
    stroke: "#1F2937",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.207 68.6265C54.5496 69.5341 53.6053 70.2886 52.4683 70.8149C51.3312 71.3413 50.041 71.621 48.7261 71.6264C47.4112 71.6317 46.1175 71.3625 44.9737 70.8455C43.83 70.3284 42.8761 69.5816 42.207 68.6794",
    stroke: "#1F2937",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15039 24.2515H9.65039L2.15039 31.7515H9.65039",
    stroke: "#818CF8",
    strokeWidth: 4.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.479 2.0249H119.979L110.479 11.5249H119.979",
    stroke: "#818CF8",
    strokeWidth: 4.04959,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.709 120.728H91.209L85.709 126.228H91.209",
    stroke: "#818CF8",
    strokeWidth: 3.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDownAi);
export default __webpack_public_path__ + "static/media/darkDownAi.833065355327fb0df0c67ee324811f5c.svg";
export { ForwardRef as ReactComponent };